module.exports = __webpack_public_path__ + "media/images/icons/filled/rocket-e63edc65a380610fa315dd5b2161d983.svg";